import * as React from "react";
const SvgFiRrBroomBall = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    {...props}
  >
    <g clipPath="url(#fi-rr-broom-ball_svg__a)">
      <path
        fill="#062147"
        d="m14.501 10.914 9.206-9.207A.999.999 0 1 0 22.293.293l-9.206 9.206-.89-.89a2.081 2.081 0 0 0-3.329.54l-.938 1.877a5.53 5.53 0 0 0-4.433 1.605C2.421 13.708 1.268 16.62.07 21.288c-.192.752.02 1.528.567 2.076a2.15 2.15 0 0 0 2.075.567c4.667-1.196 7.58-2.35 8.657-3.427a5.53 5.53 0 0 0 1.601-4.431l1.88-.94a2.078 2.078 0 0 0 .54-3.328zM9.956 19.09c-.774.775-3.668 1.86-7.739 2.904a.17.17 0 0 1-.165-.044.16.16 0 0 1-.044-.165c1.045-4.073 2.13-6.966 2.903-7.74a3.54 3.54 0 0 1 3.111-.988l2.96 2.959c.137 1.1-.243 2.29-1.026 3.074m4.001-5.746-1.879.94-2.36-2.36.94-1.88.125-.02 3.194 3.195zM20.501 17c-1.93 0-3.5 1.57-3.5 3.5s1.57 3.5 3.5 3.5 3.5-1.57 3.5-3.5-1.57-3.5-3.5-3.5m0 5c-.827 0-1.5-.673-1.5-1.5s.673-1.5 1.5-1.5 1.5.673 1.5 1.5-.673 1.5-1.5 1.5"
      />
    </g>
    <defs>
      <clipPath id="fi-rr-broom-ball_svg__a">
        <path fill="#fff" d="M0 0h24v24H0z" />
      </clipPath>
    </defs>
  </svg>
);
export default SvgFiRrBroomBall;
